import React, { createContext, useContext, useEffect, useState } from "react";
import { adminMe, getStoredToken, adminLogout as apiLogout, clearStoredToken } from "./api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
    // null = checking, false = unauthenticated, object = user
    const [user, setUser] = useState(null);

    useEffect(() => {
        const token = getStoredToken();
        if (!token) { setUser(false); return; }
        adminMe()
            .then((u) => setUser(u))
            .catch(() => { clearStoredToken(); setUser(false); });
    }, []);

    const logout = async () => {
        await apiLogout();
        setUser(false);
    };

    return (
        <AuthContext.Provider value={{ user, setUser, logout }}>
            {children}
        </AuthContext.Provider>
    );
}

export const useAuth = () => useContext(AuthContext);
